export enum BunkStatus {
  FREE,
  TAKEN,
  SELECTED,
}